module.exports = __webpack_public_path__ + "static/media/4.9ded0a4f.jpg";